/**
 * ThreeDataRequests - API helpers for Three.js scene
 * 
 * Note: Les anciennes fonctions fetchFaceData, fetchFaceGltf, getFetchFaceResponse
 * ont été supprimées car remplacées par FacesLoaderDynamic qui utilise POST /process/obj-face
 */

export const fetchSceneGlobalSettings = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/global-scene-settings`,
      {
        method: "GET",
      },
    );

    if (!response.ok) {
      throw new Error("Failed to fetch global-scene-settings");
    }

    const resGlobalSceneSettings = await response.json();
    return resGlobalSceneSettings;
  } catch (error) {
    console.error("Error fetching global-scene-settings:", error);
  }
};